import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_PROMO_CODE,
  AddPromoCodeAction,
  DELETE_PROMO_CODE,
  DeletePromoCodeAction,
  GET_PROMO_CODE,
  GET_PROMO_CODES,
  GetPromoCodeAction,
  GetPromoCodesAction,
  UPDATE_PROMO_CODE,
  UpdatePromoCodeAction,
} from "./actionTypes";
import {
  addPromoCodeError,
  addPromoCodeSuccess,
  deletePromoCodeError,
  deletePromoCodeSuccess,
  getPromoCodeError,
  getPromoCodeSuccess,
  getPromoCodesError,
  getPromoCodesSuccess,
  updatePromoCodeError,
  updatePromoCodeSuccess,
} from "./actions";
import {
  addPromoCode,
  deletePromoCode,
  getPromoCode,
  getPromoCodes,
  updatePromoCode,
} from "../../helpers/backend_helper";

function* getPromoCodesSaga({
  payload: { request, history },
}: GetPromoCodesAction) {
  try {
    const response: ResponseGenerator = yield call(
      getPromoCodes,
      request as PaginateQuery
    );
    yield put(getPromoCodesSuccess(response.data));
  } catch (error) {
    yield put(getPromoCodesError(error));
  }
}

function* getPromoCodeSaga({ payload: { id, history } }: GetPromoCodeAction) {
  try {
    const response: ResponseGenerator = yield call(getPromoCode, id);
    yield put(getPromoCodeSuccess(response.data));
  } catch (error) {
    yield put(getPromoCodeError(error));
  }
}

function* addPromoCodeSaga({
  payload: { request, history },
}: AddPromoCodeAction) {
  try {
    yield call(addPromoCode, request);
    yield put(addPromoCodeSuccess());
  } catch (error) {
    yield put(addPromoCodeError(error));
  }
}

function* updatePromoCodeSaga({
  payload: { id, request, history },
}: UpdatePromoCodeAction) {
  try {
    yield call(updatePromoCode, id, request);
    yield put(updatePromoCodeSuccess());
  } catch (error) {
    yield put(updatePromoCodeError(error));
  }
}

function* deletePromoCodeSaga({
  payload: { id, history },
}: DeletePromoCodeAction) {
  try {
    yield call(deletePromoCode, id);
    yield put(deletePromoCodeSuccess());
  } catch (error) {
    yield put(deletePromoCodeError(error));
  }
}

function* PromoCodeSaga() {
  yield takeEvery(GET_PROMO_CODES, getPromoCodesSaga);
  yield takeEvery(GET_PROMO_CODE, getPromoCodeSaga);
  yield takeEvery(ADD_PROMO_CODE, addPromoCodeSaga);
  yield takeEvery(UPDATE_PROMO_CODE, updatePromoCodeSaga);
  yield takeEvery(DELETE_PROMO_CODE, deletePromoCodeSaga);
}

export default PromoCodeSaga;
